import request from '../libs/request';
import dateFormat from 'date-fns/format';
import saveAs from 'file-saver';

const res = 'System';

export default {
  async exportFile(types) {
    const result = await request({
      url: `api/${res}/exportFile`,
      method: 'post',
      responseType: 'blob',
      data: {
        types
      }
    });

    const blob = new Blob([result], {
      type: 'application/octet-stream'
    });
    saveAs(blob, 'SystemData-' + dateFormat(new Date(), 'yyyyMMddHHmmss') + '.syd');
  }
};
